export const Theme = {
  starcheck: {
    colors: {
      main: "#266BF0",
      primary: "#00114D",
      bgColor: "rgba(38, 107, 240, .2)",
      textColor: "#2d2d2d",
    },

    space: {
      large: "100rem", //1600px
      medio: "75rem", // 1200px
    },
    padding: {
      secundary: "12.5rem", //200px
      mobile: "2rem",
      primary: "3rem", //120px
    },
  },
  log: {
    colors: {
      main: "#50D05D",
      primary: "#111111",
      bgColor: "rgba(18, 209, 167, .15)",
      textColor: "#2d2d2d",
    },

    space: {
      large: "100rem", //1600px
      medio: "75rem", // 1200px
    },
    padding: {
      secundary: "12.5rem",
      mobile: "2rem",
      primary: "3rem",
    },
  },
  vlx: {
    colors: {
      main: "#0C0C0C",
      primary: "#1C1C1C",
      bgColor: "rgba(0, 0, 0, 0.2)",
      textColor: "#2d2d2d",
    },

    space: {
      large: "100rem", //1600px
      medio: "75rem", // 1200px
    },
    padding: {
      secundary: "12.5rem",
      mobile: "2rem",
      primary: "3rem",
    },
  },
  tokyo: {
    colors: {
      main: "#E42E30",
      primary: "#353535",
      bgColor: "rgba(228, 46, 48, .2)",
      textColor: "#2d2d2d",
    },
    space: {
      large: "100rem", //1600px
      medio: "75rem", // 1200px
    },
    padding: {
      secundary: "12.5rem",
      mobile: "2rem",
      primary: "3rem",
    },
  },
};
